/**
 * Where a campaign can draw its audience from.
 *
 * Not only channels: a list the operator uploaded is a source too, and for a
 * company that works from uploads it is the only one they have.
 */

import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "./api";

export interface AudienceSource {
  kind: "channel" | "import";
  /** Channel UUID, or the import's label / batch id. */
  id: string;
  label: string;
  people: number;
}

export function useAudienceSources() {
  return useQuery<AudienceSource[]>({
    queryKey: ["audience_sources"],
    queryFn: () => api.get<AudienceSource[]>("/api/audience/sources"),
  });
}

/**
 * How many people the chosen sources actually add up to. Asks the campaign
 * preview so the number matches what the campaign will select — summing the
 * per-source counts would double-count anyone present in two channels.
 */
export function useSourceHeadcount() {
  return useMutation({
    mutationFn: (payload: { channel_ids: string[]; import_sources: string[] }) =>
      api.post<{ matched_users: number }>("/api/inviter/campaigns/preview", {
        ...payload,
        no_bots: true,
        use_live_telethon: false,
      }),
  });
}
